// extracted by mini-css-extract-plugin
export var content = "landing-page-module--content--1-HGk";
export var sections = "landing-page-module--sections--2_G4o";
export var imageButtons = "landing-page-module--imageButtons--2kXZj";
export var column = "landing-page-module--column--ch1eT";
export var imageButton = "landing-page-module--imageButton--2hPlT";
export var vepa = "landing-page-module--vepa--3nZry";
export var textWrapper = "landing-page-module--textWrapper--2uUsn";
export var message = "landing-page-module--message--23hLM";